/*
 * Module for the MemberDirect Audits Index view
*/

rs.module("system/activity/memberdirectaudits/index",

    [
        "common/visibility",
        "controls/data/grid"
    ],

    function (visibility, gridModule) {

        //
        // Initialize
        //
        function initialize(jsSelectors, seminarActivityType, lrsGridApi, backendUrl, searchToken) {
            var filterForm = $.js(jsSelectors.filterForm);
            var activityType = filterForm.js(jsSelectors.activityType);
            var memberDirectUser = filterForm.js(jsSelectors.memberDirectUser);
            var seminar = filterForm.js(jsSelectors.seminar);
            var exportSelector = filterForm.js(jsSelectors.exportSelector);
            var includeRecordOwners = filterForm.js(jsSelectors.includeRecordOwners);
            var loadingSpinner = filterForm.js(jsSelectors.loadingSpinner);

            if (searchToken) {
                loadingSpinner.show();
                var interval = setInterval(function () {
                    gridModule.update(
                        backendUrl,

                        { searchToken: searchToken },

                        lrsGridApi.agGridApi,

                        function done(gridUpdate) {
                            if (!gridUpdate.context.resultsPending) {
                                clearInterval(interval);
                                loadingSpinner.hide();
                            }
                        }
                    );
                }, 2000);
            }

            activityType.change(function () {
                if (activityType.val() == seminarActivityType) {
                    visibility.hide(memberDirectUser);
                    visibility.show(seminar);
                } else {                    
                    visibility.show(memberDirectUser);
                    visibility.hide(seminar);
                }
            });

            exportSelector.change(function () {
                if (exportSelector.val() === 'true') {
                    includeRecordOwners.prop('disabled', false);
                }
                else {
                    includeRecordOwners.prop('disabled', true);
                    includeRecordOwners.prop('checked', false);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);